// Shapes the outreach surfaces share (WEB-8739). Mirrors ActionableOutreachStep and
// StepEmailDraft in base/src/core/services/prospectingAgent/outreachActions.ts.

export type ActionableStep = {
	planId: number;
	stepId: number;
	day: number;
	channel: string;
	type: string;
	subject: string | null;
	body: string;
	contactId: number;
	contactName: string | null;
	contactTitle: string | null;
	contactEmail: string | null;
	contactPhone: string | null;
	contactLinkedin: string | null;
	clientId: number;
	clientName: string | null;
	activityId: number | null;
	activityDate: string | null;
};

export type StepEmailDraft = {
	stepId: number;
	subject: string;
	body: string;
	contact: { id: number; name: string | null; title: string | null; email: string };
	client: { id: number; name: string | null };
};

/**
 * The prospecting-agent routes are PathType.GENERIC: they answer with whatever the
 * controller returns, with no `{ data }` envelope (verified against the running API —
 * the step list arrives as a bare array, the draft as a bare object). Accept both, so
 * neither shape reads back as "nothing to do".
 */
export const unwrap = <T>(body: unknown): T | undefined => {
	const enveloped = (body as { data?: T } | null)?.data;
	return enveloped ?? (body as T) ?? undefined;
};
